module.exports = __webpack_public_path__ + "img/jtb-avatar-7568.baacd479.jpg";